// Маршруты администрирования платформы (только администратор, ключам API закрыты) — отдельно от
// ApiRoutes. Скрипт gr-sync в скиле для агентов собирается из ApiRoutes, и администрированию в нём
// не место (KIT-RULE-2). Сервер передаёт плейсхолдеры (':userId'), клиент — реальные значения.
type Id = string;

export const AdminApiRoutes = {
  // ADM-UC-1…3: обзор платформы, все блоги, пользователи онлайн.
  platform: {
    overview: '/api/admin/overview',
    storageUsage: '/api/admin/overview/storage',
    blogs: '/api/admin/blogs',
    online: '/api/admin/online',
  },
  // CFG-UC-2: настройки платформы; ключ — «раздел.параметр».
  settings: {
    list: '/api/admin/settings',
    byKey: (key: string): string => `/api/admin/settings/${key}`,
  },
  // IAM-UC-5…7: пользователи системы.
  users: {
    list: '/api/users',
    byId: (userId: Id): string => `/api/users/${userId}`,
    password: (userId: Id): string => `/api/users/${userId}/password`,
  },
  // IAM-UC-11: ключи API всех пользователей.
  apiKeys: {
    list: '/api/admin/api-keys',
    byId: (keyId: Id): string => `/api/admin/api-keys/${keyId}`,
    revoke: (keyId: Id): string => `/api/admin/api-keys/${keyId}/revoke`,
  },
  // PLAN-UC-1…4: тарифные планы и их назначение.
  plans: {
    list: '/api/admin/plans',
    byId: (planId: Id): string => `/api/admin/plans/${planId}`,
    makeDefault: (planId: Id): string => `/api/admin/plans/${planId}/default`,
    assignments: '/api/admin/plan-assignments',
    userPlan: (userId: Id): string => `/api/admin/users/${userId}/plan`,
  },
  // TASK-UC-6: фоновые задачи всех блогов и платформы.
  tasks: {
    list: '/api/admin/tasks',
    cancel: (taskId: Id): string => `/api/admin/tasks/${taskId}/cancel`,
    resume: (taskId: Id): string => `/api/admin/tasks/${taskId}/resume`,
  },
  // OPS-UC-8…11: резервные копии платформы (ADR-021); POST на список — создать копию.
  backups: {
    list: '/api/admin/backups',
    upload: '/api/admin/backups/upload',
    byName: (name: string): string => `/api/admin/backups/${name}`,
    download: (name: string): string => `/api/admin/backups/${name}/download`,
    restore: (name: string): string => `/api/admin/backups/${name}/restore`,
  },
};
